import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import home from './module/home'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    home
  },
  getters
})
